import { render, staticRenderFns } from "./mobile_footer.vue?vue&type=template&id=ca04e142"
import script from "./mobile_footer.vue?vue&type=script&lang=js"
export * from "./mobile_footer.vue?vue&type=script&lang=js"
import style0 from "./mobile_footer.vue?vue&type=style&index=0&id=ca04e142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports